/*
 *
 * PriceListCustomer constants
 *
 */

export const DEFAULT_ACTION = 'app/PriceListCustomer/DEFAULT_ACTION';
